import(/* webpackMode: "eager" */ "/home/runner/work/MONADATY/MONADATY/components/skeletons/Skeleton.tsx");
